import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-eb37cd56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage_card" }
const _hoisted_2 = { class: "card shadow-sm border-0 my-3 text-primary" }
const _hoisted_3 = { class: "card-header w-100 d-flex justify-content-between bg-transparent border-bottom-0" }
const _hoisted_4 = { class: "card-body pt-1 pb-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.body.title), 1),
        _createElementVNode("small", null, [
          _createElementVNode("i", null, _toDisplayString(_ctx.body.programArea), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, _toDisplayString(_ctx.body.body), 1),
        _createElementVNode("small", null, [
          _createElementVNode("strong", null, "Location: " + _toDisplayString(_ctx.body.location), 1)
        ]),
        _hoisted_5,
        _createVNode(_component_BaseButton, { customStyle: 'btn-primary rounded-0 mt-3' }, {
          default: _withCtx(() => [
            _createTextVNode("Send to Informatics Team")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}